import React from "react";

const Title = ({ currentSideNav }) => {
  return (
    <div className="header-title">
      {currentSideNav && <p>{currentSideNav?.label}</p>}
    </div>
  );
};

export default React.memo(Title);
